import * as React from 'react'
import { Team } from '@basehub/data/replicache/index'
import { useSelectedTeam } from './use-selected-team'
import {
  PublicTeam,
  isUserTeam,
} from '@basehub/data/replicache/mutators/_public-types'
import { useUserStore } from '~/app/_store/user-store'

/**
 *
 * @param team undefined means loading, null means "use the selected team"
 * @returns
 */
export const useMyMembershipInTeam = (
  team: Team | null | undefined | PublicTeam
) => {
  const optimisticUser = useUserStore((s) => s.optimisticUser)
  const userId = optimisticUser?.id
  const { team: selectedTeam } = useSelectedTeam()

  const teamToSearchIn = team === undefined ? team : selectedTeam

  const membership = React.useMemo(() => {
    if (teamToSearchIn === undefined) return undefined // loading
    if (!isUserTeam(teamToSearchIn)) return null
    return teamToSearchIn?.members.find((m) => m.userId === userId) ?? null
  }, [teamToSearchIn, userId])

  return membership
}
